import FormInput from './form-input.jsx';

export default FormInput;
